import url from "@/api/url.js"
import {
  post,
  get
} from "@/api/http.js";

const state = {
  id: '',
  createBy: '',
  createTime: '',
  updateBy: '',
  updateTime: '',
  remark: '',
  delFlag: '',
  status: '',
  searchValue: '',
  params: {},
  schoolCode: '',
  schoolName: '',
  establishingTime: '',
  address: '',
  logo: '',
  imageList: '',
  introduction: '',
  schoolYear: '',
  semester: ''

  // id: 1,
  // createBy: "1",
  // createTime: "2021-09-16 10:27:34",
  // updateBy: "1",
  // updateTime: "2022-01-22 16:46:01",
  // remark: "bAalnCLfEB",
  // delFlag: "0",
  // status: "0",
  // searchValue: null,
  // params: {},
  // schoolCode: "gzscxzx",
  // schoolName: "广州市长兴中学",
  // establishingTime: "1999-01-01",
  // address: "广州市天河区长兴路美景街148号",
  // logo: "",
  // imageList:
  //   "https://gimg2.baidu.com/image_search/src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180226%2Fd2f4b1eea2f240d7b23d6993b405715c.jpeg&refer=http%3A%2F%2F5b0988e595225.cdn.sohucs.com&app=2002&size=f9999,https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F013e835de7d65fa801209568f01e4f.jpg%401280w_1l_2o_100sh.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999",
  // introduction:
  //   "<p>广州市长兴中学（Guangzhou Changxing Middle School）创办于1999年，由天河区教育局举办，是一所全民义务教育中学阶段教育的公办学校，是一所实施三年制初中教育的全日制教育机构。校址毗邻华南植物园、火炉山。地化所、有色院、化学所等中科院科研院所及华南理工大学、华南农业大学等著名高校</p>",
}

const mutations = {
  SET_SCHOOL: (state, data) => {
    for (let k in state) {
      state[k] = data[k]
    }
    // state.set('schoolName, ')
    // console.log("school", state)
  },
}

const actions = {
  // 获取学校信息
  getSchool({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      // 调用获取学校信息接口
      get(`${url.getSchoolDetails}`).then(res => {
        console.log("学校信息", res)
        // 学校信息
        commit('SET_SCHOOL', res.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
